import { defineComponent as C, computed as o, useAttrs as y, openBlock as s, createElementBlock as d, createElementVNode as b, normalizeClass as v, Fragment as L, renderList as p, mergeProps as x, renderSlot as I, createCommentVNode as g } from "vue";
import { tw as h } from "../../utils/tailwind.js";
import { fluidLayoutListClass as k, fluidLayoutCardClass as A } from "./helpers/fluidLayout.helpers.js";
import { gridLayoutListClass as N, gridLayoutCardClass as O } from "./helpers/gridLayout.helpers.js";
import { responsiveLayoutListClass as S, responsiveLayoutCardClass as j } from "./helpers/responsiveLayout.helpers.js";
const B = ["aria-label", "aria-labelledby"], F = /* @__PURE__ */ C({
  name: "RevCardGrid",
  __name: "CardGrid",
  props: {
    cards: {},
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    layout: { default: "grid" }
  },
  setup(a) {
    const n = a, t = o(() => n.cards.length), i = o(() => {
      const e = y();
      return Object.keys(e).filter((l) => l.match(/^on[A-Z]+/)).reduce((l, r) => ({ ...l, [r]: e[r] }), {});
    });
    function c(e) {
      return JSON.stringify(e);
    }
    const f = o(() => {
      const e = h`grid list-none gap-12`;
      return n.layout === "fluid" ? [e, ...k(t.value)] : n.layout === "responsive" ? [e, ...S(t.value)] : [e, N()];
    });
    function m(e) {
      return e.layout === "fluid" ? A({
        cardIndex: e.cardIndex,
        cardsCount: e.cardsCount
      }) : e.layout === "responsive" ? j({
        cardIndex: e.cardIndex,
        cardsCount: e.cardsCount
      }) : O({
        cardIndex: e.cardIndex,
        cardsCount: t.value
      });
    }
    return (e, l) => a.cards.length ? (s(), d("nav", {
      key: 0,
      "aria-label": a.ariaLabel,
      "aria-labelledby": a.ariaLabelledby
    }, [
      b("ul", {
        class: v(f.value)
      }, [
        (s(!0), d(L, null, p(a.cards, (r, u) => (s(), d("li", x({
          key: c(r),
          class: m({
            cardIndex: u,
            cardsCount: t.value,
            layout: a.layout
          })
        }, { ref_for: !0 }, i.value), [
          I(e.$slots, "default", {
            card: r,
            index: u
          })
        ], 16))), 128))
      ], 2)
    ], 8, B)) : g("", !0);
  }
});
export {
  F as default
};
